// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/config-provider/style/index.less
// module id = 1105
// module chunks = 1